import { CompleteOnboardingPayload, OnboardingReducerFunction } from '../Onboarding.actions';
import updateImmutable from 'immutability-helper';
import { GetMe_me_onboarding } from '../../../../models/legacy-graphql';

export const completeOnboardingReducer: OnboardingReducerFunction<CompleteOnboardingPayload> = (state, payload) => {
  const { completeMutation, user } = payload;
  completeMutation({
    optimisticResponse: {
      completeOnboarding: updateImmutable(user, {
        onboarding: {
          completed: { $set: true }
        }
      })
    },
    update: (cache, { data }) => {
      cache.modify({
        id: cache.identify({ id: user.id, __typename: 'User' }), // TODO identify user id from payload
        fields: {
          onboarding(existingOnboarding: GetMe_me_onboarding | undefined) {
            return data ? data.completeOnboarding.onboarding : existingOnboarding;
          }
        }
      });
    }
  });
  return state;
};
